import { render, staticRenderFns } from "./VacanciesSection.htm?vue&type=template&id=6f77db4b&scoped=true&"
import script from "./VacanciesSection.ts?vue&type=script&lang=js&"
export * from "./VacanciesSection.ts?vue&type=script&lang=js&"
import style0 from "./VacanciesSection.scss?vue&type=style&index=0&id=6f77db4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f77db4b",
  null
  
)

export default component.exports